import type { AField } from '@/domain/field/AField';
import type { TextboxField } from '@/domain/textbox/TextboxField';

function isTextboxField(field: AField | undefined): field is TextboxField {
    return field?.kind === 'textbox';
}

export { isTextboxField };
